import { useEffect, useState } from 'react';
import { getExpiringImplants } from '../../services/apiService';
import ImplantVerificationDisplay from './ImplantVerificationDisplay';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';

const ImplantVerification = () => {
    // States for data, loading, and error handling
    const [implants, setImplants] = useState([]);
    const [activeImplants, setActiveImplants] = useState([]);
    const [passiveImplants, setPassiveImplants] = useState([]);
    const [implantToList, setImplantToList] = useState([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    // Fetching expiring implants
    const fetchImplantsData = async () => {
        try {
            const implantsData = await getExpiringImplants();
            const allImplants = implantsData.implants;

            // Split implants by category
            const active = allImplants.filter(
                (implant: any) => implant.Category === 'Active'
            );
            const passive = allImplants.filter(
                (implant: any) =>
                    implant.Category === 'Passive' ||
                    implant.Category === 'Stent'
            );

            setImplants(allImplants);
            setActiveImplants(active);
            setPassiveImplants(passive);
            setImplantToList(allImplants.slice(0, 100));
            setLoading(false);
            setError(null);
        } catch (error) {
            setLoading(false);
            setError(
                'There was an error fetching the data. Please try again later.'
            );
        }
    };

    useEffect(() => {
        fetchImplantsData();
    }, []);

    return (
        <div className="container mx-auto max-w-7xl px-4 py-8">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="text-2xl font-bold">Implant Verification</h1>
                    <p className="text-sm text-muted-foreground">
                        Review and verify implants based on view frequency and expiring dates.
                    </p>
                </div>
            </div>

            <Tabs defaultValue="active" className="w-full">
                <TabsList className="mb-4">
                    <TabsTrigger value="active">
                        Active Implants ({activeImplants.length})
                    </TabsTrigger>
                    <TabsTrigger value="passive">
                        Passive Implants ({passiveImplants.length})
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="active" className="mt-0">
                    <ImplantVerificationDisplay
                        implants={activeImplants}
                        loading={loading}
                        error={error}
                    />
                </TabsContent>

                <TabsContent value="passive" className="mt-0">
                    <ImplantVerificationDisplay
                        implants={passiveImplants}
                        loading={loading}
                        error={error}
                    />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export default ImplantVerification;
